import { render, staticRenderFns } from "./managementList.vue?vue&type=template&id=c2c8670c&scoped=true&"
import script from "./managementList.vue?vue&type=script&lang=js&"
export * from "./managementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c8670c",
  null
  
)

export default component.exports